import React from "react";
import { connect } from "react-redux";
import { setLoader, fetchOrdersAmplify } from "../../actions";
import requireAuth from "../requireAuth";
import AccountNav from "../AccountNav";
import history from "../../history";

class AccountOrdersPage extends React.Component {
  componentDidMount = () => {
    // Get customer email from localStorage or auth state
    const customerEmail = localStorage.email || this.props.auth?.email || '';

    if (!customerEmail) {
      this.props.setLoader(false, null);
      return;
    }

    this.props.setLoader(true, "Fetching Orders...");
    this.props.fetchOrdersAmplify(customerEmail, () => {
      this.props.setLoader(false, null);
    });
  }

  renderOrders = () => {
    if (!this.props.orders || this.props.orders.length === 0) {
      return <div className="text-muted">No orders yet</div>;
    }

    return this.props.orders.map(v => {
      let grand_total = parseFloat(v.grand_total || 0);
      grand_total = grand_total.toFixed(2);

      let shipping_address = null;
      if (v.shipping_address) {
        const street = Array.isArray(v.shipping_address.street)
          ? v.shipping_address.street[0]
          : v.shipping_address.street;
        shipping_address = (
          <React.Fragment>
            {street && <div>{street}</div>}
            <div>{v.shipping_address.city} {v.shipping_address.region_code} {v.shipping_address.postcode}</div>
          </React.Fragment>
        );
      }

      return (
        <div className="account-order" key={v.id || v.order_id}>
          <div className="account-order-increment-id">{v.increment_id}</div>
          <div>{v.customer_name}</div>
          {shipping_address}
          <div><span className="bold-description">Total:</span> <span>${grand_total}</span></div>
          <button className="account-order-view-order" onClick={() => {
            history.push(`/account/order/${v.id || v.order_id}`)
          }}>View Order</button>
        </div>
      );
    });
  }

  render() {
    return (
      <div id="page-account-orders">
        <AccountNav />
        <div id="account-content">
          <h1 className="h1">Orders</h1>
          <div id="account-orders">
            {this.renderOrders()}
          </div>    
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    orders: state.orders.orders,
    auth: state.auth,
  };
};

export default requireAuth(
  connect(
    mapStateToProps,
    { setLoader, fetchOrdersAmplify }
  )(AccountOrdersPage)
);
